import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AirlineService } from '../../services/airline.service';
import { AccountsService } from '../../services/accounts.service';


@Component({
  selector: 'ngx-term-condition',
  templateUrl: './terms-conditions.component.html',
})
export class TermsConditions implements OnInit {
  Termsconditions: FormGroup; 
  submitted = false; 
  loading = false; 
  content: string = ''; // For displaying fetched content
  termId:number;

  constructor(private formBuilder: FormBuilder, private router: Router,private _airlineservice:AirlineService,private account:AccountsService
     ) {}

  ngOnInit(): void {
    // Initialize the form
    this.Termsconditions = this.formBuilder.group({
      Content: ['', Validators.required], 
      TermId: ['', Validators.required],
    });

    // Fetch terms and conditions content on load
    this.getTermsConditions();
  }

  get f() {
    return this.Termsconditions.controls;
  }

  getTermsConditions(): void {
    this.account.getsTermsConditions().subscribe(
      (data) => {
        
        if (!data['isError'] && data['code'] === 200) {
          const terms = data['payload'][0];
          this.termId=terms.termId;
          console.log('trrryryryr'+this.termId); 
          this.content = terms.content;
          console.log('hfsksssdjskd'+this.content);
        
           this.Termsconditions.patchValue({
            Content: this.content, 
            TermId:this.termId
           });
        }
      },
      (error) => {
       
      }
    );
  }

  onSubmit(): void {
    this.submitted = true;

    if (this.Termsconditions.invalid) {
      return;
    }

    this.loading = true;
    const formData = {
      content: this.Termsconditions.get('content')?.value,
      termId: this.termId,
      isAccepted: true,

      
    };
    

    setTimeout(() => {
      this.loading = false;
      this.router.navigate(['/terms-conditions']);
    }, 200); 
  }
}
